// todos los aeropuertos que vuela flybondi para hacer una comparacion con los que vuela aerolineas

export const AEROPUERTOS_FLYBONDI = [
	'BRC',
	'CNQ',
	'COR',
	'CRD',
	'FLN',
	'FTE',
	'GIG',
	'GRU',
	'IGR',
	'JUJ',
	'MDZ',
	'NQN',
	'PDP',
	'PMY',
	'PSS',
	'SDE',
	'SLA',
	'TUC',
	'UAQ',
	'USH',
	'AEP',
	'EZE',
	'ASU'
];
